import React from "react";
import '../Reset.css';
import '../App.css';

export default class MidTeacher extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      days: [],
    }
    this.groupByKey = this.groupByKey.bind(this)
    this.days = this.days.bind(this)
  }

  groupByKey = (list, key, { omitKey = false }) => list.reduce((hash, { [key]: value, ...rest }) => ({ ...hash, [value]: (hash[value] || []).concat(omitKey ? { ...rest } : { [key]: value, ...rest }) }), {})
  componentDidUpdate(prevProps) {
    if (this.props.arrA !== prevProps.arrA && this.props.arrA.length) {
      const daysArray = this.groupByKey(this.props.arrA, 'day_number', { omitKey: true })
      const days = this.days(daysArray)
      //группировка массива по Wee
      this.setState({
        days
      })
    }
  }
  times(times) {
    const timesArray = this.groupByKey(times, 'id_time', { omitKey: true })

    return Object.keys(timesArray).map(timeId => {
      let prev = null
      let time = null
      return timesArray[timeId].map((times) => {

        if (prev == times.Time_) {
          time = ""

        } else {
          time = times.Time_
          prev = times.Time_
        }
        return (
          <table>
            <tr>
              <td className="td__time">
                
                <span> {time}</span>  </td>
              <td>
                <span className="italic"> {times.EveryWeek}</span>
                <span className="TypeName">{times.StudyTypeName} </span>
                <span className="discipline">{times.discipline} </span>

                <span className="audit">{times.AuditoryName}</span>
                <span className="group">{times.Groups} </span>
                            {times.nedely}</td>
            </tr>
          </table>
        )
      })
    })
  }

  days(daysArray) {
    return Object.keys(daysArray).map(day => {
      return (
        <center>
          <div className="grid__carts">
            <div className="times">
              <div className="day">
                <p className="dayName">{daysArray[day][0].WeekDayName}</p>
                {this.times(daysArray[day])}
              </div>
            </div>
          </div>
        </center>
      )
    });
  }


  render() {
    if (this.props.arrA.length) {
      return (
        <div>
          {this.state.days}
        </div>
      )

    }

    else {
      return (
        <div>
          <div className="container">
            <div class="loader-wrapper">
              <div class="loader-points">
                <div class="loader-point">
                  <div class="point point-1"></div>
                  <div class="point-shadow point-shadow-1"></div>
                </div>
                <div class="loader-point">
                  <div class="point point-2"></div>
                  <div class="point-shadow point-shadow-2"></div>
                </div>
                <div class="loader-point">
                  <div class="point point-3"></div>
                  <div class="point-shadow point-shadow-3"></div>
                </div>
              </div>
              <p class="loader-text" style={{ visibility: "hidden" }}>Нет данных</p>
            </div>
          </div>
        </div>
      )
    }
  }
}
